var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_16)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", null)))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.0646796226501465,0,0,2.0646796226501465,256,257.8599853515625)",
    opacity: 0.015248204981509304,
    style: {
      display: "none"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,-3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(4,191,141)",
    fillOpacity: 1,
    d: " M0,-118 C65.12419891357422,-118 118,-65.12419891357422 118,0 C118,65.12419891357422 65.12419891357422,118 0,118 C-65.12419891357422,118 -118,65.12419891357422 -118,0 C-118,-65.12419891357422 -65.12419891357422,-118 0,-118z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M0,-118 C65.12419891357422,-118 118,-65.12419891357422 118,0 C118,65.12419891357422 65.12419891357422,118 0,118 C-65.12419891357422,118 -118,65.12419891357422 -118,0 C-118,-65.12419891357422 -65.12419891357422,-118 0,-118z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5,0,0,1.5,256,257.8599853515625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,-3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(4,191,141)",
    fillOpacity: 1,
    d: " M0,-118 C65.12419891357422,-118 118,-65.12419891357422 118,0 C118,65.12419891357422 65.12419891357422,118 0,118 C-65.12419891357422,118 -118,65.12419891357422 -118,0 C-118,-65.12419891357422 -65.12419891357422,-118 0,-118z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,256,256)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 30,
    d: " M-82.5,4.5 C-82.5,4.5 -31,55 -31,55 C-31,55 73,-52.5 73,-52.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.957c5db232decf7d4a2eb4d5615760c4.svg";
export { ForwardRef as ReactComponent };